/**
 * ── THE CARD LADDER, FOR THE PAGE ───────────────────────────────────────
 *
 * Daniel, 2026-10-09: more cards in one order, less for each —
 * 2 → 10%, 3–4 → 15%, 5–9 → 25%, 10+ → 30%, per order, any card, any person.
 *
 * The discount is a checkout Function (picturepops-free-card → card-ladder).
 * The cart draws its own prices in Liquid from what Shopify applied
 * (sections/cart-page.liquid). This file is the same table for the builder:
 * window.PPLadder.percentFor(n) and .label(n), used by the Send step's button.
 *
 * Behind Theme settings → Card ladder. With it off (Live ships so), `on` is
 * false and every helper answers as if there were no ladder.
 */
(function () {
  'use strict';

  var cfg = window.PP_LADDER || {};
  var mode = cfg.mode === 'on' || cfg.mode === 'preview' ? cfg.mode : 'off';

  var tiers = String(cfg.tiers || '').replace(/\s+/g, '').split(',').map(function (p) {
    var a = p.split(':');
    return { min: Number(a[0]), percent: Number(a[1]) };
  }).filter(function (t) {
    return Number.isInteger(t.min) && t.min >= 2 && t.percent > 0 && t.percent < 100;
  }).sort(function (a, b) { return a.min - b.min; });

  var on = mode !== 'off' && tiers.length > 0;

  function percentFor(cards) {
    if (!on) return 0;
    var pct = 0;
    tiers.forEach(function (t) { if (cards >= t.min) pct = t.percent; });
    return pct;
  }

  /** The next step up from `cards`, or null at the top. */
  function next(cards) {
    if (!on) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].min > cards) return { need: tiers[i].min - cards, percent: tiers[i].percent };
    }
    return null;
  }

  /** "15% off each" for an order of `cards`, or '' below the first step. */
  function label(cards) {
    var pct = percentFor(cards);
    return pct ? pct + '% off each' : '';
  }

  // Cards already in the cart, so the builder can count the whole order —
  // the ladder is per order, not per add. Fetched once, lazily.
  var inCart = null;
  function cartCards() {
    if (inCart) return inCart;
    var postage = Number(window.PP_POSTAGE_VARIANT || 0);
    inCart = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).reduce(function (n, it) {
          return postage && Number(it.variant_id) === postage ? n : n + (Number(it.quantity) || 0);
        }, 0);
      })
      .catch(function () { return 0; });
    return inCart;
  }

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, params || {});
    } catch (e) { /* analytics never stops a purchase */ }
  }

  // The cart's "one more person" line: counted once per page view, so we can
  // later see whether people who read it add another card.
  function noteNudge() {
    var el = document.querySelector('[data-pp-ladder-nudge]');
    if (!el) return;
    track('pp_ladder_nudge_seen', {
      cards: Number(el.getAttribute('data-cards')) || 0,
      next_percent: Number(el.getAttribute('data-next')) || 0,
      mode: mode
    });
  }
  if (on) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', noteNudge);
    else noteNudge();
  }

  var api = window.PPLadder = {
    on: on, mode: mode, tiers: tiers, inCartNow: 0,
    percentFor: percentFor, next: next, label: label, cartCards: cartCards
  };
  // The builder's button reads inCartNow synchronously; fill it once.
  if (on && document.querySelector('[data-pp-builder], .pp-builder, #pp-builder, [x-data]')) {
    cartCards().then(function (n) { api.inCartNow = n; });
  }
})();
